<app-header-four></app-header-four>

<section class="page-title-area">
    <div class="container">
        <div class="page-title-content">
            <h2>Reportes</h2>
            <ul>
                <li><a routerLink="/">Inicio</a></li>
                <li>Reportes</li>
            </ul>
        </div>
    </div>
</section>

<section class="blog-details-area ptb-100">
    <div class="container">
        <div class="row">
            <div class="col-lg-8 col-md-12">
                <div class="blog-details-desc">
                    <div class="article-image">
                        <img src="assets/img/blog/img1.jpg" alt="Presentación del libro">
                    </div>

                    <div class="article-content">
                        <div class="entry-meta">
                            <ul>
                                <li>
                                    <i class='bx bx-folder-open'></i>
                                    <span>Categoría</span>
                                    <a routerLink="/blog-details">Eventos</a>
                                </li>
                                <li>
                                    <i class='bx bx-group'></i>
                                    <span>Visitas</span>
                                    <a routerLink="/blog-details">1,245</a>
                                </li>
                                <li>
                                    <i class='bx bx-calendar'></i>
                                    <span>Fecha</span>
                                    <a routerLink="/blog-details">Marzo 2026</a>
                                </li>
                            </ul>
                        </div>

                        <h3>Presentación del libro de la Fundación Acosta Ñu</h3>

                        <p>
                            En un emotivo evento realizado en Asunción, la Fundación Acosta Ñu llevó a cabo la presentación oficial de su libro institucional, 
                            una obra que recoge años de trabajo solidario, historias de vida y el impacto generado en distintas comunidades del Paraguay.
                        </p>

                        <p>
                            El evento contó con la presencia de autoridades, voluntarios, beneficiarios y público en general, quienes acompañaron este importante 
                            hito que refleja el compromiso de la fundación con el desarrollo social y el bienestar de las familias más necesitadas.
                        </p>

                        <blockquote class="wp-block-quote">
                            <p>Este libro representa el esfuerzo colectivo de muchas personas que creen en un Paraguay más solidario.</p>
                            <cite>Representante de la Fundación</cite>
                        </blockquote>

                        <p>
                            Durante la presentación, se destacaron proyectos como la construcción de pozos artesianos, sistemas de agua potable y diversas 
                            iniciativas comunitarias desarrolladas en diferentes departamentos del país.
                        </p>

                        <ul class="wp-block-gallery columns-3">
                            <li class="blocks-gallery-item">
                                <figure>
                                    <img src="assets/img/blog/img2.jpg" alt="Evento">
                                </figure>
                            </li>

                            <li class="blocks-gallery-item">
                                <figure>
                                    <img src="assets/img/blog/img3.jpg" alt="Presentación">
                                </figure>
                            </li>

                            <!--li class="blocks-gallery-item">
                                <figure>
                                    <img src="assets/img/blog/img4.jpg" alt="Participantes">
                                </figure>
                            </li-->
                        </ul>

                        <h3>Un testimonio del impacto social</h3>
                        <ul class="features-list">
                            <li><i class='bx bx-badge-check'></i> Relatos reales de comunidades beneficiadas</li>
                            <li><i class='bx bx-badge-check'></i> Proyectos de acceso al agua potable</li>
                            <li><i class='bx bx-badge-check'></i> Participación de voluntarios y aliados</li>
                            <li><i class='bx bx-badge-check'></i> Compromiso con el desarrollo sostenible</li>
                        </ul>

                        <h3>Compromiso que trasciende</h3>
                        <p>
                            La Fundación reafirmó su misión de continuar impulsando acciones solidarias, fortaleciendo la ayuda social y promoviendo 
                            oportunidades para comunidades vulnerables en todo el país.
                        </p>

                        <h3>Un evento que inspira</h3>
                        <p>
                            La presentación del libro no solo fue un acto institucional, sino también un espacio de reflexión e inspiración, 
                            donde se resaltó la importancia de la solidaridad y el trabajo conjunto.
                        </p>
                    </div>

                    <div class="article-footer">
                        <div class="article-tags">
                            <span><i class='bx bx-purchase-tag'></i></span>
                            <a routerLink="/">Fundación</a>,
                            <a routerLink="/">Eventos</a>,
                            <a routerLink="/">Solidaridad</a>
                        </div>

                        <div class="article-share">
                            <ul class="social">
                                <li><span>Compartir:</span></li>
                                <li><a href="#" class="facebook"><i class='bx bxl-facebook'></i></a></li>
                                <li><a href="#" class="instagram"><i class='bx bxl-instagram'></i></a></li>
                                <li><a href="#" class="linkedin"><i class='bx bxl-linkedin'></i></a></li>
                            </ul>
                        </div>
                    </div>

                    <div class="qovid-post-navigation">
                        <div class="prev-link-wrapper">
                            <a routerLink="/blog-details">
                                <span class="prev-title">Jornada solidaria en comunidades rurales</span>
                                <span class="date-post">Febrero 2014</span>
                            </a>
                        </div>

                        <div class="next-link-wrapper">
                            <a routerLink="/blog-details">
                                <span class="next-title">Nuevos proyectos de agua potable en el interior</span>
                                <span class="date-post">Abril 2026</span>
                            </a>
                        </div>
                    </div>

                    <div class="comments-area">
                        <h3 class="comments-title">Comentarios:</h3>

                        <ol class="comment-list">
                            <li class="comment">
                                <div class="comment-content">
                                    <p>
                                        Excelente iniciativa. Este tipo de proyectos realmente marcan la diferencia en las comunidades.
                                    </p>
                                </div>
                            </li>

                            <li class="comment">
                                <div class="comment-content">
                                    <p>
                                        Felicitaciones a la fundación por el trabajo y por compartir estas historias inspiradoras.
                                    </p>
                                </div>
                            </li>
                        </ol>

                        <div class="comment-respond">
                            <h3 class="comment-reply-title">Dejar un comentario</h3>

                            <form class="comment-form">
                                <p class="comment-form-author">
                                    <label>Nombre</label>
                                    <input type="text" placeholder="Tu nombre">
                                </p>

                                <p class="comment-form-email">
                                    <label>Email</label>
                                    <input type="email" placeholder="Tu correo">
                                </p>

                                <p class="comment-form-comment">
                                    <label>Comentario</label>
                                    <textarea placeholder="Escribe tu comentario..."></textarea>
                                </p>

                                <p class="form-submit">
                                    <input type="submit" value="Publicar comentario">
                                </p>
                            </form>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-12">
                <aside class="widget-area">

                    <!--section class="widget widget_search">
                        <input type="search" placeholder="Buscar...">
                    </section-->

                    <!--section class="widget widget_qovid_posts_thumb">
                        <h3 class="widget-title">Publicaciones recientes</h3>

                        <article class="item">
                            <span>Febrero 2026</span>
                            <h4><a routerLink="/blog-details">Entrega de kits solidarios</a></h4>
                        </article>

                        <article class="item">
                            <span>Enero 2026</span>
                            <h4><a routerLink="/blog-details">Voluntariado en comunidades</a></h4>
                        </article>
                    </section-->

                    <!--section class="widget widget_categories">
                        <h3 class="widget-title">Categorías</h3>
                        <ul>
                            <li><a routerLink="/">Eventos</a></li>
                            <li><a routerLink="/">Proyectos</a></li>
                            <li><a routerLink="/">Solidaridad</a></li>
                        </ul>
                    </section-->

                    <!--section class="widget widget_tag_cloud">
                        <h3 class="widget-title">Etiquetas</h3>
                        <div class="tagcloud">
                            <a routerLink="/">Fundación</a>
                            <a routerLink="/">Agua</a>
                            <a routerLink="/">Voluntariado</a>
                            <a routerLink="/">Paraguay</a>
                        </div>
                    </section-->

                </aside>
            </div>
        </div>
    </div>
</section>